import {Observable} from 'rxjs';

const getObservable = <T>(fromObservable: Observable<T> | (() => Observable<T>)): Observable<T> =>
    typeof fromObservable === 'function' ? fromObservable() : fromObservable;
export default getObservable;
